import React from 'react';

interface FieldZoneIconProps {
  color?: string;
  size?: number;
}

const FieldZoneIcon: React.FC<FieldZoneIconProps> = ({
  color = '#696F88',
  size = 15
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    aria-hidden="true"
    data-testid="field-zone-icon"
  >
    <path
      d="M5 5.83333C5 5.3731 5.3731 5 5.83333 5H9.16667C9.6269 5 10 5.3731 10 5.83333V9.16667C10 9.6269 9.6269 10 9.16667 10H5.83333C5.3731 10 5 9.6269 5 9.16667V5.83333Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66667 0H3.33333V1.66667L11.6667 1.66667V0H13.3333V1.66667L15 1.66667V3.33333H13.3333V11.6667H15V13.3333H13.3333V15H11.6667V13.3333L3.33333 13.3333V15H1.66667V13.3333H0V11.6667H1.66667V3.33333H0V1.66667L1.66667 1.66667V0ZM3.33333 11.6667V3.33333L11.6667 3.33333V11.6667H3.33333Z"
      fill={color}
    />
  </svg>
);

export default FieldZoneIcon;
